import styled, { css } from 'styled-components';

import { caption, overline, title } from '@/components/Typography/v2/font-styles';
import { color as colorMixin, Color } from '@/components/Typography/v2/font-color';

export type baseElementProps = {
  color?: Color;
  gridArea?: string;
};

const baseElement = css<baseElementProps>`
  ${({ gridArea }) => gridArea && `grid-area: ${gridArea};`}

  ${({ color }) => colorMixin(color)}
`;

export const Title2 = styled.h2<baseElementProps>`
  ${baseElement}

  ${title('title-2')}
`;
export const Title4 = styled.h4<baseElementProps>`
  ${baseElement}

  ${title('title-4')}
`;

export const Overline = styled.p<baseElementProps>`
  ${baseElement}

  ${overline}
`;

export const Caption = styled.p<baseElementProps>`
  ${baseElement}

  ${caption}
`;
